import { Box, CircularProgress, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CustomPieChart from './CustomPieChart';
import CustomBarChart from './CustomBarChart';
import { IDashboard } from '../../interfaces/dashboard.ts';

interface CustomBarChartProps {
	data: IDashboard | undefined;
}

const DashboardCharts: React.FC<CustomBarChartProps> = ({ data }) => {
	const { t } = useTranslation();

	return (
		<Grid container className="flex w-full flex-col gap-x-4 md:flex-row">
			<Grid item md={4}>
				<Typography className="mb-4 text-xl font-medium text-text-primary">{t('recent-ads-stats')}</Typography>
				<Box className="flex h-80 items-center justify-center rounded-2xl bg-background-paper">
					<CustomPieChart data={data} />
				</Box>
			</Grid>
			<Grid item className="flex-1">
				<Typography className="mb-4 text-xl font-medium text-text-primary">{t('weekly-activity')}</Typography>
				<Box className="flex h-80 items-center justify-center rounded-2xl bg-background-paper">{data ? <CustomBarChart data={data} /> : <CircularProgress />}</Box>
			</Grid>
		</Grid>
	);
};

export default DashboardCharts;
